export const colors = [
  '#EF4444',
  '#F97316',
  '#FACC15',
  '#4ADE80',
  '#0EA5E9',
  '#6366F1',
  '#FE2713',
  '#1B1B1B',
  '#F43F5E',
  '#D946EF',
  '#8B5CF6',
  '#3337FB',
  '#10B981',
  '#84CC16'
];
